import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LivechatComponent } from 'src/app/features/livechat/livechat.component';
import { AppdataService } from 'src/app/services/app-data/appdata.service';

@Component({
  selector: 'app-annotation-dialog-utility',
  templateUrl: './annotation-dialog-utility.component.html',
  styleUrls: ['./annotation-dialog-utility.component.scss']
})
export class AnnotationDialogUtilityComponent {
  pickedColor: any;
  appConfig: any;
  actionsToRight: any;
  confirmToRight: any;

  constructor(
    public dialogRef: MatDialogRef<LivechatComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private appdataService: AppdataService
  ) {
    this.appConfig = this.appdataService.getConfig();
    this.actionsToRight = this.appConfig.Miscellaneous?.ButtonArrangement?.actionsToRight;
    this.confirmToRight = this.appConfig.Miscellaneous?.ButtonArrangement?.confirmToRight;
  }

  onChooseColor() {
    this.dialogRef.close(this.pickedColor);
  }

  onClearAnnotation() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
